"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getPolicyLink = getPolicyLink;
exports.linkByLocale = void 0;

var _i18n = require("../i18n");

var linkByLocale = {
  'en-US': 'https://www.thomsonreuters.com/en/privacy-statement.html',
  'fr-CA': 'https://www.thomsonreuters.com/fr-ca/privacy-statement.html',
  'nl-NL': 'https://www.thomsonreuters.com/nl/privacy.html',
  'es-AR': 'https://www.thomsonreuters.com/es/declaracion-de-privacidad.html',
  'pt-BR': 'https://www.thomsonreuters.com/pt/declaracao-de-privacidade.html'
};
exports.linkByLocale = linkByLocale;

function getPolicyLink() {
  return linkByLocale[(0, _i18n.getCurrentLanguage)(false)] || linkByLocale['en-US'];
}
